/* eslint-disable @typescript-eslint/naming-convention */
import type { ActionBanner } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { CMSCTA, CMSHTML } from '@swf/cms';
import { select } from '@swf/core/store';

import CMSPreloadImage from '../CMSPreloadImage/CMSPreloadImage';

import styles from './CMSActionBanner.scss';

const CMSActionBanner: React.FC<ActionBanner> = ({
  uid,
  content,
  display_desktop,
  display_mobile,
  desktop_image,
  mobile_image,
  left_button,
  right_button,
  foot_note
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const desktopImageUrl = desktop_image.asset?.url;
  const desktopHeight = desktop_image.height ? `${desktop_image.height}px` : '50vh';
  const mobileImageUrl = mobile_image.asset?.url;
  const mobileHeight = mobile_image.height ? `${mobile_image.height}px` : '50vh';
  const imgUrl = isMobile ? mobileImageUrl || desktopImageUrl : desktopImageUrl || mobileImageUrl;
  const hasButtons = left_button?.url || right_button?.url;

  return (
    <>
      {imgUrl && <CMSPreloadImage imageUrl={imgUrl} />}
      <Helmet>
        <style type="text/css">{`
        #${uid} {
            background-image: url("${mobileImageUrl}");
            height: ${mobileHeight};
        }

        @media only screen and (min-width: 725px) {
          #${uid} {
            background-image: url("${desktopImageUrl}");
            height: ${desktopHeight};
          }
        }
    `}</style>
      </Helmet>
      <div id={uid} className={styles.container}>
        <div>
          <CMSHTML className={styles.content} {...content} />
        </div>
        {(hasButtons || !!foot_note) && (
          <div>
            {hasButtons && (
              <div
                className={classNames(styles.actionButtons, {
                  [styles.desktopVisible]: display_desktop,
                  [styles.mobileVisible]: display_mobile
                })}
              >
                {!!left_button?.url && <CMSCTA {...left_button} />}
                {!!right_button?.url && <CMSCTA {...right_button} />}
              </div>
            )}
            {!!foot_note && <p className={styles.footNote}>{foot_note}</p>}
          </div>
        )}
      </div>
    </>
  );
};

export default CMSActionBanner;
